import {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    object,
    moreNav,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
} from './ThirdMapping';

import { removeDataFromMap, setDatabotsNavMap } from 'js/vue/helpers';

var databots = {
    activity: 'proforma-overview__menu--activity',
    informations: 'proforma-overview__menu--general-info',
    financialactivity: 'proforma-overview__menu--financial-info',
    contacts: 'proforma-overview__menu--contact-linked',
    addresses: 'proforma-overview__menu--address',
    customfields: 'proforma-overview__menu--cf',
    statistics: 'proforma-overview__menu--stat',
    opportunity: 'proforma-overview__menu--opportunity',
    estimate: 'proforma-overview__menu--document',
    invoice: 'proforma-overview__menu--document',
    delivery: 'proforma-overview__menu--document',
    order: 'proforma-overview__menu--document',
    creditnote: 'proforma-overview__menu--document',
    proforma: 'proforma-overview__menu--document',
    payments: 'proforma-overview__menu--payment',
    bankaccount: 'proforma-overview__menu--bank-account',
    recurring: 'proforma-overview__menu--recurring',
    mandates: 'proforma-overview__menu--mandate',
    timetracking: 'proforma-overview__menu--timetracking',
    tickets: 'proforma-overview__menu--ticket',
    project: 'proforma-overview__menu--project',
    proposal: 'proforma-overview__menu--proposal',
    emailingprofile: 'proforma-overview__menu--mailing-list',
    massmailingMailinglist: 'proforma-overview__menu--mailing-list',
    massmailingCampaignList: 'proforma-overview__menu--mailing-list',
    receipts: 'proforma-overview__menu--receipt',
    briefcase: 'proforma-overview__menu--briefcase',
    activitycommentadd: 'proforma-overview__activity--comment-add',
    emailadd: 'proforma-overview__activity--email-add',
    calladd: 'proforma-overview__activity--call-add',
    taskadd: 'proforma-overview__activity--task-add',
    eventadd: 'proforma-overview__activity--event-add',
    generalinfoedit1: 'proforma-overview__section--general-info-edit-1',
    generalinfoedit2: 'proforma-overview__section--general-info-edit-2',
    marketing: 'proforma-overview__section--marketing',
};

setDatabotsNavMap(navMap, databots);

const dataToRemove = [
    {
        key: 'financial',
        values: ['account', 'auxiliaryCode'],
    },
];

removeDataFromMap(dataToRemove, dataMap);

var entitiesGroups = [
    {
        label: Loc.g('Activité'),
        value: 'clientActivity',
        entities: [
            'task',
            'event',
            'annotation',
            'email',
            'phonecall',
            'prospect',
            'timetracking',
            'ticket',
            'snippettracking',
            'marketing',
        ],
    },
    {
        label: Loc.g('Prospection'),
        value: 'prospection',
        entities: ['campaign', 'opportunity', 'estimate', 'propdocument'],
    },
    {
        type: 'component',
        component: 'timeline-author-filter',
        label: Loc.g('Collaborateurs'),
        value: 'authors',
        filter: true,
        entities: [],
        display: 'block',
    },
];

var entitiesTabs = [
    {
        label: Loc.g('Activité'),
        value: 'activity',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Éléments épinglés'),
        value: 'pinned',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Commentaires'),
        value: 'note',
        entities: ['annotation'],
        databot: 'proforma-overview__activity--comment-list',
    },
    {
        label: Loc.g('Emails'),
        value: 'email',
        entities: ['email'],
        databot: 'proforma-overview__activity--email-list',
    },
    {
        label: Loc.g('Tâches'),
        value: 'task',
        entities: ['task'],
        databot: 'proforma-overview__activity--task-list',
    },
    {
        label: Loc.g('Evènements'),
        value: 'event',
        entities: ['event'],
        databot: 'proforma-overview__activity--event-list',
    },
    {
        label: Loc.g('Appels'),
        value: 'phonecall',
        entities: ['phonecall'],
        databot: 'proforma-overview__activity--call-list',
    },
    {
        label: Loc.g('Marketing'),
        value: 'marketing',
        entities: ['marketing'],
        databot: 'proforma-overview__activity--marketing-list',
    },
];

var defaultEntities = [
    'email',
    'phonecall',
    'prospect',
    'annotation',
    'event',
    'task',
    'timetracking',
    'ticket',
    'campaign',
    'opportunity',
    'estimate',
    'propdocument',
    'snippettracking',
    'marketing',
];

var forcedLabel = [
    {
        value: 'prospect',
        label: Loc.g('Mises à jour'),
    },
];

var availableStatCards = ['estimate_third'];

export {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    entitiesGroups,
    entitiesTabs,
    defaultEntities,
    forcedLabel,
    object,
    moreNav,
    availableStatCards,
    databots,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
};
